import { render, staticRenderFns } from "./TimeStrategy.vue?vue&type=template&id=4d7f3a52&"
import script from "./TimeStrategy.vue?vue&type=script&lang=js&"
export * from "./TimeStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports